var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "margin-top": "20px" } },
    [
      _vm.isCancelOne
        ? _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("listOfSet.tabulation"),
                    name: "tabsTable",
                  },
                },
                [
                  _vm.tabsName === "tabsTable"
                    ? _c("keysetPage", { attrs: { dataIdOne: _vm.dataId } })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: { label: _vm.$t("listOfSet.form"), name: "tabsForm" },
                },
                [
                  _vm.tabsName === "tabsForm"
                    ? _c("formSetPage", {
                        attrs: { dataIdTwo: _vm.dataId, isString: true },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("listOfSet.codeEvent"),
                    name: "tabsCodeEvent",
                  },
                },
                [
                  _vm.tabsName === "tabsCodeEvent"
                    ? _c("codeEventSet", { attrs: { dataIdThree: _vm.dataId } })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("listOfSet.Language"),
                    name: "tabsLanguage",
                  },
                },
                [
                  _vm.tabsName === "tabsLanguage"
                    ? _c("languageSet", {
                        attrs: {
                          dataIdFour: _vm.dataId,
                          typeFour: _vm.dataType,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("listOfSet.sheetPage"),
                    name: "tabsSheet",
                  },
                },
                [
                  _vm.tabsName === "tabsSheet"
                    ? _c("sheetPage", { attrs: { dataIdFive: _vm.dataId } })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }